import { actions, changes } from './actions.js';
import { inputs, presentClick, presentKey, uploadRefs } from './hooks.js';

// No menu entry: the brief lives inside a project (Projects tab) and is also opened from the Roster.
export default {
  id: 'brief', nav: false, actions, changes, inputs,
  keys: [presentKey], clicks: [presentClick],
  uploads: { ref: uploadRefs }
};
